import { render, staticRenderFns } from "./BottomCards.vue?vue&type=template&id=ae521d2e&scoped=true"
import script from "./BottomCards.vue?vue&type=script&lang=js"
export * from "./BottomCards.vue?vue&type=script&lang=js"
import style0 from "./BottomCards.vue?vue&type=style&index=0&id=ae521d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae521d2e",
  null
  
)

export default component.exports